
import {create} from 'zustand';
import { supabase } from '../../../config';
import RoleService from '../../../services/roleService';

const useUserInvitesStore = create((set, get) => ({
  loading: true,
  canSendInvites: false,
  userProfile: null,
  setLoading: (loading) => set({ loading }),
  checkInvitePermission: async (userId) => {
    if (!userId) {
      set({ loading: false });
      return;
    }
    try {
      const isSuperAdmin = await RoleService.checkSuperAdmin(userId);
      if (isSuperAdmin) {
        set({ canSendInvites: true, loading: false });
        return;
      }
      const userProducts = await RoleService.getUserProducts(userId);
      const hasCreatorOrSupport = userProducts.some(
        product => product.role === 'creator' || product.role === 'support'
      );
      set({ canSendInvites: hasCreatorOrSupport, loading: false });
    } catch (error) {
      console.error('Error checking invite permission:', error);
      set({ canSendInvites: false, loading: false });
    }
  },
  fetchUserProfile: async (userId) => {
    if (!userId) return;
    try {
      const { data, error } = await supabase
        .from('user_profiles')
        .select('first_name, last_name')
        .eq('id', userId)
        .single();
      if (!error && data) {
        set({ userProfile: data });
      }
    } catch (error) {
      console.error('Error loading user profile:', error);
    }
  },
}));

export default useUserInvitesStore;
